document.addEventListener('DOMContentLoaded', () => {
    const $searchForm = document.getElementById('search-form');

    if ($searchForm) {
        const $searchInput = $searchForm.querySelector('.input');

        $searchForm.addEventListener('submit', (event) => {
            const value = $searchInput.value.trim();

            if (value === '') {
                event.preventDefault();
                $searchInput.focus();
            }
        });
    }
});
